<template>
  <div class="Operations_page">
    <div class="content_box">
      <div
        class="video_box"
        v-for="(item, index) of instructionList"
        :key="index"
      >
        <el-card @click="toQQ(item)">
          <img
            :src="item.image"
            class="image"
            v-if="item.instructionType === 'VIDEO'"
            @click="toSeeVideo(item)"
          />
          <div class="qq_box" v-else>
            <span class="bold"> 方和印刷客服QQ： </span>
            {{ item.qq }}
          </div>
          <div style="padding: 24px">
            <span class="title">{{ item.title }}</span>
            <div class="bottom clearfix">
              <time class="subtitle">{{ item.desc }}</time>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog
      :visible.sync="videiModel.flag"
      width="850px"
      class="model_box"
      @close="closeModel"
    >
      <div>
        <video :src="videiModel.videoUrl" width="800" controls autoplay></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInstructionApi } from "../../api/index";
export default {
  data() {
    return {
      instructionList: [
        {
          videoUrl: "https://vip.yin61.com/static/media/zcys.542721e.mp4",
          image: require("../../assets/img/pic1.png"),
          title: "会员注册演示",
          desc: "点击图片观看演示视频",
          qq: "",
          instructionType: "VIDEO",
        },
        {
          videoUrl: "https://vip.yin61.com/static/media/xdys.35e8bca.mp4",
          image: require("../../assets/img/pic2.png"),
          title: "下单流程演示",
          desc: "点击图片观看演示视频",
          qq: "",
          instructionType: "VIDEO",
        },
        {
          videoUrl: "https://vip.yin61.com/static/media/plscys.95239b6.mp4",
          image: require("../../assets/img/pic3.png"),
          title: "批量上传演示",
          desc: "点击图片观看演示视频",
          qq: "",
          instructionType: "VIDEO",
        },
        {
          videoUrl: "",
          image: "",
          title: "其他事宜",
          desc: "联系客服QQ进行咨询",
          qq: "800181038",
          instructionType: "QQ",
        },
      ],
      videiModel: {
        flag: false,
        videoUrl: "",
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    toSeeVideo(item) {
      this.videiModel = {
        flag: true,
        videoUrl: item.videoUrl,
      };
    },
    closeModel() {
      this.videiModel = {
        flag: false,
        videoUrl: "",
      };
    },
    getInfo() {
      getInstructionApi()
        .then((res) => {
          if (res.resultStatus) {
            this.instructionList = res.resultData.instructionList || [];
          } else {
            this.instructionList = [];
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    toQQ(data) {
      if(data.instructionType === "QQ") {
        window.open(`tencent://message/?uin=${data.qq}`);
      }
    },
  },
};
</script>

<style lang="less">
.Operations_page {
  width: 100%;
  height: 100%;
  @media screen and (min-width: 480px) {
    .content_box {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      .video_box {
        width: calc(33% - 20px);
        margin-right: 20px;
        margin-bottom: 20px;
      }
      .bottom {
        margin-top: 13px;
        line-height: 12px;
      }
      .image {
        width: 100%;
        height: 180px;
        display: block;
        cursor: pointer;
      }
      .qq_box {
        width: 100%;
        height: 180px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        color: rgb(255, 104, 1);
        .bold {
          font-weight: bold;
          color: #000000;
        }
      }
      .title {
        overflow: hidden;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
        font-size: 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .subtitle {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
      }
      .el-card__body,
      .el-main {
        padding: 0;
      }
      .model_box {
      }
    }
  }
  @media only screen and (max-width: 480px) {
  }
}
</style>